import { Heart, Shield, Clock, MessageCircle } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold mb-4">
              Læge Ledig Notifikation
            </h3>
            <p className="text-gray-300 mb-6 max-w-md">
              En gratis tjeneste der hjælper danske borgere med at finde ledige læger 
              ved at overvåge findlæge.dk og sende øjeblikkelige notifikationer via Telegram.
            </p>
            
            <div className="flex items-center space-x-4">
              <div className="flex items-center text-sm text-gray-400">
                <Heart className="w-4 h-4 mr-2 text-red-400" />
                Lavet med kærlighed til Danmark
              </div>
            </div>
          </div>
          
          {/* Service Features */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Tjeneste</h4>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-center">
                <Shield className="w-4 h-4 mr-2 text-green-400" />
                100% Gratis
              </li>
              <li className="flex items-center">
                <Clock className="w-4 h-4 mr-2 text-blue-400" />
                Daglig overvågning
              </li>
              <li className="flex items-center">
                <MessageCircle className="w-4 h-4 mr-2 text-purple-400" />
                Telegram notifikationer
              </li>
              <li className="flex items-center">
                <Shield className="w-4 h-4 mr-2 text-yellow-400" />
                Privatliv beskyttet
              </li>
            </ul>
          </div>
          
          {/* Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Information</h4>
            <ul className="space-y-3 text-gray-300">
              <li>
                <a href="#faq" className="hover:text-white transition-colors">
                  Ofte stillede spørgsmål
                </a>
              </li>
              <li>
                <a 
                  href="https://findlæge.dk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  findlæge.dk
                </a>
              </li>
              <li>
                <a 
                  href="https://telegram.org" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Om Telegram
                </a>
              </li>
              <li>
                <button className="hover:text-white transition-colors text-left">
                  Privatlivspolitik
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      {/* Privacy Notice */}
      <div className="border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="bg-gray-800 rounded-lg p-6">
            <h4 className="text-lg font-semibold mb-3 flex items-center">
              <Shield className="w-5 h-5 mr-2 text-green-400" />
              Privatliv og datasikkerhed
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-gray-300">
              <div>
                <h5 className="font-medium text-white mb-2">Hvad vi gemmer:</h5>
                <ul className="space-y-1">
                  <li>• Dit Telegram chat ID (anonymt)</li>
                  <li>• Læge URLs du har tilføjet</li>
                  <li>• Tidspunkt for tilføjelse</li>
                </ul>
              </div>
              <div>
                <h5 className="font-medium text-white mb-2">Hvad vi IKKE gemmer:</h5>
                <ul className="space-y-1">
                  <li>• Dit navn eller telefonnummer</li>
                  <li>• Telegram beskeder</li>
                  <li>• Personlige oplysninger</li>
                </ul>
              </div>
            </div>
            <p className="text-xs text-gray-400 mt-4">
              Du kan til enhver tid slette alle dine data ved at skrive til vores Telegram bot.
            </p>
          </div>
        </div>
      </div>
      
      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-400 mb-4 md:mb-0">
              © {currentYear} Læge Ledig Notifikation. Alle rettigheder forbeholdes.
            </div>
            
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span>Lavet i Danmark 🇩🇰</span>
              <span>•</span>
              <span>Open Source</span>
              <span>•</span>
              <span>Ikke-kommerciel</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer